/**
 * Type guard for Error instances
 */
export function isError(value: unknown): value is Error {
  return value instanceof Error
}

/**
 * Type guard for objects with message property
 */
export function hasMessage(value: unknown): value is { message: string } {
  return (
    typeof value === "object" &&
    value !== null &&
    "message" in value &&
    typeof (value as { message: unknown }).message === "string"
  )
}

/**
 * Type guard for Firebase HttpsError
 */
export function isHttpsError(
  value: unknown,
): value is { code: string; message: string } {
  return (
    typeof value === "object" &&
    value !== null &&
    "code" in value &&
    "message" in value &&
    typeof (value as { code: unknown }).code === "string" &&
    typeof (value as { message: unknown }).message === "string"
  )
}

/**
 * Extract error message from unknown error
 */
export function getErrorMessage(error: unknown): string {
  if (isError(error)) return error.message
  if (hasMessage(error)) return error.message
  if (typeof error === "string") return error
  return "An unknown error occurred"
}
